import { GenreGroupMenuBookInfoType, IMenu } from 'apis/types';
import { DisplayTimingGroupResults } from 'utils/displayTimingGroup';
import { isMenuSlotRendered } from 'utils/isMenuSlotRendered';

/**
 * Tells whether a subgenre still renders at least one menu item inside the given genre.
 * This matches the condition under which `#subgenre-menu-${subgenreId}` exists in the DOM,
 * so a faire banner is only shown when its scroll target is actually there.
 */
export function isSubgenreVisibleInGenre(
  subgenreId: string,
  genre: GenreGroupMenuBookInfoType | undefined,
  menuData?: IMenu,
  shinagire: string[] = [],
  displayTimingGroupResults: DisplayTimingGroupResults = {}
): boolean {
  if (!genre) return false;

  const targetSubgenre = genre.subgenre.find((subgenre) => subgenre.subgenre_id === subgenreId);
  if (!targetSubgenre?.menu?.length) return false;

  return targetSubgenre.menu.some((menuSlot) =>
    isMenuSlotRendered(menuSlot, menuData, shinagire, displayTimingGroupResults)
  );
}
